export const ICON_NAME_MAP = {
  avatar_40: 'User',
  person_24: 'User',
  user_24: 'User',
  circle_icon_person_40: 'UserCircle',
  avatarPlus5_64: 'UsersFour',
  avatarPlus5_24: 'UsersFour',
  people_64: 'Users',
  two_avatar_arrow_64: 'Users',
  family_24: 'UsersThree',
  houseAndPerson_64: 'UserSquare',
  circlePersonSparkleLight_64: 'UserCircleDashed',
  personSparkle_64: 'PersonSimpleRun',
  twoPeopleTalkLegal_64: 'UserSound',
  userFocus_24: 'UserFocus',
  baby_24: 'Baby',
  carriage_24: 'BabyCarriage',

  accident_64: 'Ambulance',
  accident_40: 'Ambulance',
  brain_24: 'Brain',
  dogEmergency_24: 'FirstAidKit',
  drip_64: 'Stethoscope',
  stethoscope_64: 'Stethoscope',
  scalpel_64: 'Hospital',
  hospital_24: 'Hospital',
  surgeon_64: 'Syringe',
  pill_24: 'Pill',
  pillWithLine_24: 'Pill',
  pillWithBox_64: 'Pill',
  pillWithClock_64: 'ClockCountdown',
  tooth_64: 'Tooth',
  molar_24: 'Tooth',
  calendarTooth_64: 'Tooth',
  clipboardWithCross_64: 'ClipboardText',
  clipboardWithWave_64: 'Heartbeat',
  virus_24: 'Virus',
  bed_24: 'Bed',

  dog_64: 'Dog',
  dogBone_40: 'Bone',
  bone_24: 'Bone',
  crossWithPaw_24: 'PawPrint',
  doghouse_24: 'House',
  heartWithPaw_64: 'Heart',

  bike_24: 'Bicycle',
  bikeAccessories_24: 'PersonSimpleBike',
  bikeAlert_24: 'Warning',
  car_40: 'CarSimple',
  carOutline_40: 'CarSimple',
  carFilled_40: 'CarSimple',
  carOutline_64: 'CarSimple',
  carDamage_24: 'WarningOctagon',
  carOutlinePatch_24: 'Bandaids',
  bandaids_24: 'Bandaids',
  hexwrenchCar_40: 'GearSix',
  steeringWheel_40: 'SteeringWheel',
  drone_40: 'Drone',
  plane_64: 'PaperPlaneTilt',
  airplane_24: 'Airplane',
  train_64: 'TrainRegional',
  train_40: 'TrainRegional',
  carBrandLightBg_104: 'CarProfile',
  carPlayground3LightBg_104: 'Car',
  carWithParkingSignPlayground5LightBg_104: 'LetterCircleP',
  carWithPatchPlayground2LightBg_104: 'Bandaids',
  carWithMagifyingGlassPlayground4LightBg_104: 'MagnifyingGlass',
  carWithPlusIconPlayground5LightBg_104: 'PlusCircle',
  flagFinishPlayground3LightBg_104: 'FlagCheckered',

  burningMoney_40: 'Flame',
  burningMoney_24: 'Money',
  money_64: 'MoneyWavy',
  coinWithChart_64: 'HandCoins',
  coinWithChart_24: 'ChartLineUp',
  holdMoney_40: 'HandCoins',
  holdMoney_64: 'HandCoins',
  piggyBank_64: 'PiggyBank',
  coins_24: 'Coins',
  wallet_money_64: 'Wallet',
  cardAndLetter_24: 'CreditCard',
  card_24: 'CreditCard',
  boost_64: 'ChartLineUp',
  discount_64: 'SealPercent',
  discountGreen_64: 'SealPercent',
  circlePercent_24: 'SealPercent',
  discount_tag_64: 'Tag',
  reward_24: 'Medal',
  shoppingCart_64: 'ShoppingCart',
  calculator_40: 'Calculator',
  fiveKg_64: 'NumberCircleFive',
  fiveKg_40: 'NumberCircleFive',

  germanDocument_40: 'FileText',
  pdf_24: 'FilePdf',
  pdf_document_40: 'FilePdf',
  gavel_64: 'Gavel',
  circleGavel_24: 'Gavel',
  lawyerTalk_64: 'Scales',
  lawyerTalk_40: 'Scales',
  legalDoc_40: 'Stamp',
  legalDoc_64: 'Stamp',
  legalWork_64: 'Scroll',
  legalWork_40: 'Scroll',
  list_24: 'ListChecks',

  house_40: 'House',
  propertyDamage_64: 'House',
  propertyDamage_40: 'House',
  house_with_key_64: 'HouseLine',
  houses_64: 'Buildings',
  couch_64: 'Couch',
  couch_24: 'Couch',
  table_64: 'PicnicTable',
  temple_24: 'Bank',
  keypadWithFinger_40: 'Numpad',
  key_64: 'Key',

  boom_64: 'Lightning',
  boomNoBackground_64: 'Lightning',
  boom_24: 'Lightning',
  lightning_64: 'Lightning',
  cloudLightning_24: 'CloudLightning',
  lightningCloud_24: 'CloudLightning',
  fire_64: 'Fire',
  fire_40: 'Fire',
  water_64: 'Drop',
  brokenGlass_24: 'ImageBroken',
  brokenWindow_64: 'ImageBroken',
  circleDamage_64: 'ImageBroken',
  circleDamage_24: 'ImageBroken',
  thief_24: 'SmileyAngry',

  calendar_64: 'CalendarDots',
  calendar_40: 'CalendarDots',
  calendarCancel_64: 'CalendarSlash',
  calendarCancel_40: 'CalendarSlash',
  calendarFour_64: 'Calendar',
  calendarOne_64: 'Calendar',
  calendarThree_64: 'Calendar',
  calendarTwo_64: 'Calendar',
  calendarTime_64: 'CalendarBlank',
  clock_64: 'Clock',
  stopwatch_64: 'Timer',

  microchip_24: 'Cpu',
  laptop_64: 'Laptop',
  smartphone_64: 'DeviceMobile',
  buy_in_app_40_41x40: 'DeviceMobile',
  buy_in_web_40_41x40: 'Browser',
  videocall_24: 'VideoCamera',
  videocallOutline_64: 'VideoCamera',
  phone_64: 'Phone',
  phone_white_outline_64: 'Phone',
  phone_solid_24: 'Phone',
  phone_white_outline_24: 'Phone',
  hotline24_64: 'PhoneCall',
  hotline24_40: 'PhoneCall',
  concierge_24: 'CallBell',

  shieldWithCheckmark_64: 'ShieldCheck',
  shieldWithInfo_64: 'ShieldWarning',
  circleShield_24: 'Shield',
  lifebuoy_64: 'Lifebuoy',
  globalCover_64: 'GlobeHemisphereWest',
  peaceOfMind_64: 'HandHeart',
  handHeart_24: 'HandHeart',
  infinity_64: 'Infinity',

  outdoor_24: 'Tree',
  renewable_energy_24: 'Leaf',
  palm_24: 'Island',
  sun_24: 'Sun',
  sunbed_24: 'Sun',
  swimming_pool_24: 'SwimmingPool',
  suitcase_24: 'SuitcaseSimple',
  snack_64: 'Orange',
  briefcase_40: 'Briefcase',
  diamond_ring_24: 'SketchLogo',
  box_24: 'Package',
  eye_24: 'Eye',
  gift_24: 'Gift',
  cheers_24: 'Cheers',
  clown_24: 'Confetti',
  sparkle_64: 'Sparkle',
  thumbs_up_64: 'ThumbsUp',
  chatBubbleWithDots_24: 'ChatCircleDots',
  chatBubbleWithQuestionMark_24: 'SealQuestion',
  sealQuestion_24: 'SealQuestion',
  spyglass_64: 'MagnifyingGlass',
  toothMagnifying_64: 'MagnifyingGlass',
  toothMagnifying_40: 'MagnifyingGlass',
  magnifyingGlass_40: 'MagnifyingGlass',
  spyglassWithCheckmark_64: 'SealCheck',
  globe_24: 'Globe',
  heartInMarker_64: 'MapPin',
  location_pin_64: 'MapPinLine',
  directionSign_40: 'Signpost',

  heart_64: 'Heart',
  heart2_64: 'Heart',
  circleHeart_24: 'Heart',
  heartHalf_24: 'HeartHalf',
  handsClapping_24: 'HandsClapping',
  circleSmile_24: 'Smiley',
  happy_24: 'Smiley',
  happyInactive_24: 'Smiley',
  neutral_24: 'SmileyMeh',
  neutralInactive_24: 'SmileyMeh',
  sad_24: 'SmileyNervous',
  sadInactive_24: 'SmileyNervous',
  unhappy_24: 'SmileySad',
  unhappyInactive_24: 'SmileySad',
  sadFace_64: 'SmileySad',
  veryHappy_24: 'SmileyWink',
  veryHappyInactive_24: 'SmileyWink',

  hexwrench_64: 'Wrench',
  hexwrench_40: 'Wrench',
  wrench_64: 'Wrench',
  slider_64: 'FadersHorizontal',
  fadersHorizontal_24: 'FadersHorizontal',
  toggle_40: 'ToggleRight',
  circlePencil_40: 'PencilCircle',
  circlePencil_24: 'PencilCircle',

  circleCheckmark_24: 'CheckCircle',
  circleCheckmarkGreen_24: 'CheckCircle',
  circleCheckmarkLightWithGreenBg_24: 'CheckCircle',
  circleCheckmark_disabled_24: 'CheckCircle',
  circleCheckMarkUiGreenWithLightBg_40: 'CheckCircle',
  checkmark_64: 'Check',
  blackCheckmark_24: 'Check',
  checkmarkWhite_14x11: 'Check',
  circles_24: 'Target',
  circlePlay_24: 'PlayCircle',
  circle_info_40: 'Info',
  InfoIconNew_16: 'Info',
  circleInfoActive_16: 'Info',
  circleInfoDisabled_16: 'Info',
  InfoIconNewWhite_16: 'Info',
  circleExclamationMarkUiOrangeWithLightBg_40: 'ExclamationMark',
  circleExclamationMarkUiRedWithLightBg_40: 'ExclamationMark',
  circleExclamationMarkUiRedWithLightRedBg_64: 'ExclamationMark',
  warning_64: 'Warning',
  circleMinus_24: 'MinusCircle',
  lightBulb_24: 'Lightbulb',
  dot_24: 'DotOutline',

  arrow_24: 'ArrowLeft',
  arrowRight_24: 'ArrowRight',
  arrowRightUiLight_24: 'ArrowRight',
  chevronDown_24: 'CaretDown',
  chevronDown_16: 'CaretDown',
  chevronDownUiLight_24: 'CaretDown',
  chevronLeft_24: 'CaretLeft',
  chevronRight_24: 'CaretRight',
  chevronRight_16: 'CaretRight',
  chevronRightBrandDark_16: 'CaretRight',
  chevronRightUiOrange_16: 'CaretRight',
  chevronRightUiLight_24: 'CaretRight',
  chevronRightUiRed_24: 'CaretRight',
  chevronRightUiRed_16: 'CaretRight',
  chevronRightDouble_24: 'CaretDoubleRight',
  chevronUp_24: 'CaretUp',
  chevronUp_16: 'CaretUp',
  circleArrowDown_40: 'ArrowCircleDown',
  circleArrowUp_40: 'ArrowCircleUp',
  externalLink_24: 'ArrowSquareOut',
  externalLink_uiLight_24: 'ArrowSquareOut',
  reload_24: 'ArrowClockwise',
  attachment_24: 'Paperclip',
  download_24: 'DownloadSimple',
  share_24: 'Export',
  shareIos_24: 'UploadSimple',
  plus_64: 'Plus',
  plusUiLight_16: 'Plus',
  cross_64: 'X',
  close_24: 'X',
  close_16: 'X',
  closeUiRed_16: 'X',
  crossSmallRed_24: 'X',
  circleClose_24: 'XCircle',
  circleCross_24: 'XCircle',

  circleInfo_24: 'Info',
  circleInfoUiRed_24: 'Info',
  infoIconCircleBlack_24: 'Info',
  circleQuestionMark_24: 'Question',
  circlePlus_24: 'PlusCircle',
  circleExclamationMark_24: 'ExclamationMark',
  star_24: 'Star',
  star_64: 'Star',
  mail_24: 'Envelope',
  trashbin_24: 'Trash',
  documents_24: 'Files',
} as const

export type LegacyIconName = keyof typeof ICON_NAME_MAP
export type PhosphorIconName = (typeof ICON_NAME_MAP)[LegacyIconName]

const ICON_SIZE_SUFFIX_REGEX = /_(\d+)(?:[_x]\d+)*$/

const getLegacyIconBaseName = (legacyIconName: string): string =>
  legacyIconName.replace(ICON_SIZE_SUFFIX_REGEX, '')

const buildBaseIconNameMap = () => {
  const targetsByBase: Record<string, Set<PhosphorIconName>> = {}

  for (const [legacyName, phosphorName] of Object.entries(ICON_NAME_MAP)) {
    const base = getLegacyIconBaseName(legacyName)
    targetsByBase[base] = (targetsByBase[base] ?? new Set()).add(phosphorName)
  }

  return Object.fromEntries(
    Object.entries(targetsByBase)
      .filter(([, targets]) => targets.size === 1)
      .map(([base, targets]) => [base, [...targets][0]])
  )
}

const BASE_ICON_NAME_MAP = buildBaseIconNameMap()

export const isLegacyIcon = (iconName: string): iconName is LegacyIconName =>
  Object.prototype.hasOwnProperty.call(ICON_NAME_MAP, iconName)

export const mapLegacyIconToPhosphor = (legacyIconName: string) => {
  if (isLegacyIcon(legacyIconName)) {
    return ICON_NAME_MAP[legacyIconName]
  }

  return BASE_ICON_NAME_MAP[getLegacyIconBaseName(legacyIconName)] ?? null
}
